<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {online} from "@/utils/websocket/websocket";
import {getToken} from "@/utils/admin";
import {mapActions, mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters(['socket', 'autoReconnect']),
  },
  methods:{
    ...mapActions({
      setSocket: 'setSocket',
      setOnlineState: 'setOnlineState',
      setOnlineDisabled: 'setOnlineDisabled',
      clearHistoryMessage: 'clearHistoryMessage',
      addToHistoryMessage: 'addToHistoryMessage',
    }),
  },
  mounted() {
    setInterval(()=>{
      if (!getToken()) {
        return
      }
      if (this.autoReconnect && (!this.socket || this.socket.readyState !== 1)) {
        online(this, this.socket)
      }
    }, 2000)
  },
}
</script>